/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 3/1/2023
 */

import Vue from "@/entry/setupVue3.js"

const asyncLoad = async () => {
	try{
		let VueSessionStorage = await import('@external/vue-sessionstorage')
		VueSessionStorage = VueSessionStorage.default
		console.log("VueSessionStorage = ", VueSessionStorage)
		Vue.use(VueSessionStorage)
	}catch (error){
		console.error(error)
		//crash happens in iframe in chrome incognito mode
		//https://stackoverflow.com/questions/30481516/iframe-in-chrome-error-failed-to-read-localstorage-from-window-access-deni
		//providing a fallback in that case
		Vue.config.globalProperties.$session = {
			get(key){},
			set(key, value){},
			exists(key){},
			remove(key){},
			clear(key){},
		}
	}
}

let _ = asyncLoad()
